import { localisedValue } from "utils"

const clientProfileFilterOptionsTransformer = (response, meta) => {
  const data = response?.data || response

  if (!data || !data.options) {
    return []
  }

  const options = data.options

  // Special handling for servicesRequired filter
  const filterKey = meta?.arg
  if (filterKey === "servicesRequired") {
    return data?.groupedQuestions?.map(option => ({
      label: localisedValue({ object: option, key: "title" }) || option.name || option.key,
      value: option.filterName || option.value || option.id?.toString(),
      key: option.filterName || option.value || option.id?.toString(),
    }))
  }

  // Default handling for other filters
  return options.map(option => {
    const value = option.value || option.key || option.id?.toString()
    const label = option.displayTitle || localisedValue({ object: option, key: "name" }) || option.name || option.key

    return {
      ...option,
      label,
      title: label,
      value,
      key: option.value || option.key || option.id?.toString(),
    }
  })
}

export default clientProfileFilterOptionsTransformer
